import request from '@/api/request'

export function fetchList(params) {
    return request({
        url: '/model-analysis/asset/purchase/list',
        params,
    })
}

export function add(data) {
    return request({
        url: '/model-analysis/asset/purchase/add',
        method: 'post',
        data,
    })
}

export function fetchDetail({ id }) {
    return request({
        url: '/model-analysis/asset/purchase/query/' + id,
    })
}

// 审核通过
export function review(data) {
    return request({
        url: '/model-analysis/asset/purchase/review',
        method: 'post',
        data,
    })
}
// 接收
export function accept(data) {
    return request({
        url: '/model-analysis/asset/purchase/accept',
        method: 'post',
        data,
    })
}

// 取消申请
export function cancel(data) {
    return request({
        url: '/model-analysis/asset/purchase/cancel',
        method: 'post',
        data,
    })
}

// 删除
export function remove(data) {
    return request({
        url: '/model-analysis/asset/purchase/delete',
        method: 'post',
        data,
    })
}

// 重新发起审批
export function edit(data) {
    return request({
        url: '/model-analysis/asset/purchase/update',
        method: 'post',
        data,
    })
}